export {
  projects
}
let projects=[
  {
    image:require('@/assets/images/project/project1.png'),
    name:'碎石生产线',
    english: 'Stone Production Line',
    id: '101',
    title1: '电气控制箱( Electrical Control Box )',
    desc: [
      '产品描述：我们的电气控制系统安装了国际和国内知名品牌的电器元件，是您可以信赖的产品。此外，我们还安装了漏电保护装置、电力系统继电保护、自动限位开关和警铃等安全装置，使操作更容易、更安全、更可靠。',
      '适用范围包括：造船、重工业、机床、化工机械、建筑、消防、环保、配电、能源生产和仪器仪表。',
      '表面处理：镀锌材料，不锈钢。',
      '附件：配电柜：床、可调梁、电缆夹柚木。控制箱：防水顶盖、墙面固定支架、墙面固定脚、立柱固定件、轴环。控制面板：床，可调梁，铝杆，支架。'
    ],
    engDesc: [
      'Product Description: Installed with international and national famous brands electrical components, our electrical control system is the product that you can rely on. Moreover, ' +
      'such safety devices as electric leakage protection device, relay protection of power  system, automatic limited switch and the alert bell are installed to ' +
      'make operation easier, safer and more reliable.',
      'Application Scope Includes: Ship building, heavy industry, machine tools, chemical machinery, construction, fire control, environmental protection, power distribution, ' +
      'energy production, and instruments.',
      'Surface Treatment: Galvanized Material, stainless steel.',
      'Attachments: Distribution Cabinet: bed, adjustable beam, cable clamp teak. Control Box: water-proof top cap, wall fixed bracket, wall fixed feet, column fixed parts, ' +
      'shaft collar. Control Panel: bed, adjustable beam, Aluminum rod, cradle.'
    ],
    imageList: [require('@/assets/images/project/scx.png')]
  },
  {
    image:require('@/assets/images/project/project2.png'),
    name:'开采石头样本',
    english: 'Mining Stone Samples',
    id: '102',
    imageList: [require('@/assets/images/project/ks.png')]
  },
  {
    image:require('@/assets/images/project/jgsb.png'),
    name:'加工设备',
    english: 'Processing equipment',
    id: '103',
    imageList: [require('@/assets/images/project/jgsb1.png')]
  },
  {
    image:require('@/assets/images/project/cpzs.png'),
    name:'成品展示',
    english: 'Finished product display',
    id: '104',
    imageList: [require('@/assets/images/project/cpzs1.png')]
  },
]
